import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

import { colors } from "@dotnet/telematics-design-system";

const NoPermissionIcon = (props: SvgIconProps) => {
    const { white } = colors;

    return (
        <SvgIcon viewBox="0 0 120 120" {...props}>
            <g clipPath="url(#clip0_49_10888)" fill="none">
                <g clipPath="url(#clip1_49_10888)">
                    <path
                        d="M60.1681 15C71.4301 15 80.5681 24.138 80.5681 35.4V46.956H39.7681V35.4C39.7681 24.138 48.9061 15 60.1681 15Z"
                        stroke="#70B8FF"
                        strokeWidth="6"
                        strokeMiterlimit="10"
                    />

                    <path
                        d="M87.5761 42.498H64.2781V98.58H72.3601C84.2881 98.58 93.9601 88.908 93.9601 76.98V48.888C93.9601 45.36 91.0981 42.504 87.5761 42.504V42.498Z"
                        fill="url(#paint0_linear_49_10888)"
                    />

                    <path
                        d="M32.7601 42.498H78.5701C82.0921 42.498 84.9541 45.36 84.9541 48.882V76.98C84.9541 88.902 75.2761 98.58 63.3541 98.58H47.9701C36.0481 98.58 26.3701 88.902 26.3701 76.98V48.882C26.3701 45.36 29.2321 42.498 32.7541 42.498H32.7601Z"
                        fill="#C5E2FF"
                    />

                    <path
                        d="M62.2681 69.8344C62.2681 66.1864 59.3161 63.2344 55.6681 63.2344C52.0201 63.2344 49.0681 66.1864 49.0681 69.8344C49.0681 72.3964 50.5321 74.6164 52.6681 75.7084V80.4724C52.6681 82.1284 54.0121 83.4724 55.6681 83.4724C57.3241 83.4724 58.6681 82.1284 58.6681 80.4724V75.7084C60.8041 74.6164 62.2681 72.3964 62.2681 69.8344Z"
                        fill="#70B8FF"
                    />

                    <g style={{ mixBlendMode: "multiply" }} opacity="0.5">
                        <path
                            d="M62.2681 69.8407C62.2681 72.4027 60.8041 74.6287 58.6681 75.7207V80.4787C58.6681 82.1347 57.3241 83.4787 55.6681 83.4787C54.9181 83.4787 54.2341 83.2027 53.7061 82.7467C53.9881 82.8307 54.2881 82.8787 54.6001 82.8787C56.2561 82.8787 57.6001 81.5347 57.6001 79.8787V75.1207C57.9781 74.9287 58.3381 74.7007 58.6681 74.4367C60.2101 73.2307 61.2001 71.3467 61.2001 69.2407C61.2001 66.9847 60.0661 64.9927 58.3381 63.8047C60.6541 64.8307 62.2681 67.1467 62.2681 69.8407Z"
                            fill="#70B8FF"
                        />
                    </g>

                    <path
                        d="M6 104.052H114.336"
                        stroke="#70B8FF"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </g>
            </g>

            <defs>
                <linearGradient
                    id="paint0_linear_49_10888"
                    x1="64.2781"
                    y1="70.536"
                    x2="93.9601"
                    y2="70.536"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.58" stopColor="#70B8FF" />
                    <stop offset="1" stopColor="#C5E2FF" />
                </linearGradient>

                <clipPath id="clip0_49_10888">
                    <rect width="120" height="120" fill={white} />
                </clipPath>

                <clipPath id="clip1_49_10888">
                    <rect width="120" height="120" fill={white} />
                </clipPath>
            </defs>
        </SvgIcon>
    );
};

export default NoPermissionIcon;
